import { ExpressionRule } from "../../ExpressionRule";
import { ExpressionValue } from "../../ExpressionValue";
import { DateDataDefinition } from "../../../Common/Data/Definitions/DateDataDefinition";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { NumberDataDefinition } from "../../../Common/Data/Definitions/NumberDataDefinition";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class DateGetYearExpression extends ExpressionRule {
    readonly __type: string = "Date Get Year";
    readonly __ruleName: string = "Get Year";
    value1: ExpressionValue;

    constructor() {
        super();

        this.expressionValueType = new NumberDataDefinition();
        this.value1 = ExpressionValue.createExpressionValue(this, "dateValue", new DateDataDefinition());
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return this.value1.evaluate(data, testContext).getFullYear();
    }
}
